export default __webpack_public_path__ + "static/media/kalayanakatta.22e90457.svg";